export const RootEntityContextParameterId = 'Entity';
